import { css } from 'styled-components'

import { helpers } from './theme'

export const types = css`
	h1,
	h2,
	h3,
	h4,
	h5 {
		margin: 2.75rem 0 1.05rem;
		line-height: 1.15;
		font-weight: 400;
		font-family: ${helpers.font.family.header};
	}

	h1 {
		font-size: ${helpers.font.size.h1};
		margin: 12px 0;
		font-weight: 600;
		line-height: 44px;
	}

	h2 {
		font-size: ${helpers.font.size.h2};
		font-weight: 600;
		line-height: 24px;
	}

	h3 {
		font-size: ${helpers.font.size.h3};
	}

	p {
		margin: 0 0 24px;
	}

	small {
		font-size: ${helpers.font.size.small};
	}

	ul {
		margin: 0;
		padding: 0;
	}

	a {
		color: ${helpers.color.link};
		text-decoration: none;
	}
`
